import { useEffect, useRef } from "react";

// Live data for the /app side, the same idea as the admin's utils/adminLive:
// the app layout polls the signed-in account (notifications) and, when
// something new lands (a paid document, a reply...), emits APP_LIVE_EVENT.
// Any page on screen re-fetches its data quietly. Pages also refresh on a
// timer and when the tab comes back into view, so My Documents and friends
// keep up without a reload, for guests too.
export const APP_LIVE_EVENT = "app-live";

export function emitAppLive(detail = {}) {
  try { window.dispatchEvent(new CustomEvent(APP_LIVE_EVENT, { detail })); } catch { /* ignore */ }
}

// useAppLive(refetch, { every }) — `refetch` is called with `true` (silent)
// so a page keeps its current rows on screen (no spinner) while the fresh
// ones arrive.
export function useAppLive(refetch, { every = 60000 } = {}) {
  const ref = useRef(refetch);
  ref.current = refetch;
  useEffect(() => {
    const visible = () => typeof document === "undefined" || document.visibilityState !== "hidden";
    const run = () => { if (visible()) ref.current?.(true); };
    window.addEventListener(APP_LIVE_EVENT, run);
    document.addEventListener("visibilitychange", run);
    const iv = every ? setInterval(run, every) : null;
    return () => {
      window.removeEventListener(APP_LIVE_EVENT, run);
      document.removeEventListener("visibilitychange", run);
      if (iv) clearInterval(iv);
    };
  }, [every]);
}
